export enum LevelOfExperience {
  StartingOut = 'STARTING_OUT',
  SomewhatExperienced = 'SOMEWHAT_EXPERIENCED',
  HighlyExperienced = 'HIGHLY_EXPERIENCED',
  IncrediblyExperienced = 'INCREDIBLY_EXPERIENCED',
}
